import { render, staticRenderFns } from "./react-native-image-size-picker.vue?vue&type=template&id=d81a9fec"
import script from "./react-native-image-size-picker.vue?vue&type=script&lang=ts"
export * from "./react-native-image-size-picker.vue?vue&type=script&lang=ts"
import style0 from "./react-native-image-size-picker.vue?vue&type=style&index=0&id=d81a9fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports